export const filterValueObject = (value, value2) => {
  return value && value2 && Object.fromEntries(Object.entries(value).filter(n => (n[1] !== value2) && (n[1] !== null)));
};

export const deleteResetValue = (value) => {
  return value && Object.fromEntries(Object.entries(value).filter(n => (n[1] !== 'reset')));
};